import api from '@/api/api';

export default {
    // ===== USUÁRIOS =====
    async listarUsuarios() {
        const response = await api.get('/permissions/usuarios');
        return response.data;
    },

    async criarUsuario(dadosUsuario) {
        const response = await api.post('/permissions/usuarios', dadosUsuario);
        return response.data;
    },

    async atualizarUsuario(login, dadosUsuario) {
        const response = await api.put(`/permissions/usuarios/${login}`, dadosUsuario);
        return response.data;
    },

    async deletarUsuario(login) {
        const response = await api.delete(`/permissions/usuarios/${login}`);
        return response.data;
    },

    // ===== APLICAÇÕES =====
    async listarAplicacoes() {
        const response = await api.get('/permissions/aplicacoes');
        return response.data;
    },

    async criarAplicacao(dadosAplicacao) {
        const response = await api.post('/permissions/aplicacoes', dadosAplicacao);
        return response.data;
    },

    async atualizarAplicacao(appName, dadosAplicacao) {
        const response = await api.put(`/permissions/aplicacoes/${appName}`, dadosAplicacao);
        return response.data;
    },

    async deletarAplicacao(appName) {
        const response = await api.delete(`/permissions/aplicacoes/${appName}`);
        return response.data;
    },

    // ===== GRUPOS =====
    async listarGrupos() {
        const response = await api.get('/permissions/grupos');
        return response.data;
    },

    async criarGrupo(dadosGrupo) {
        const response = await api.post('/permissions/grupos', dadosGrupo);
        return response.data;
    },

    async atualizarGrupo(groupId, dadosGrupo) {
        const response = await api.put(`/permissions/grupos/${groupId}`, dadosGrupo);
        return response.data;
    },

    async deletarGrupo(groupId) {
        const response = await api.delete(`/permissions/grupos/${groupId}`);
        return response.data;
    },

    async copiarPermissoes(groupIdDestino, groupIdOrigem) {
        const response = await api.post(`/permissions/grupos/${groupIdDestino}/copiar-permissoes`, {
            group_id_origem: groupIdOrigem
        });
        return response.data;
    },

    // ===== PERMISSÕES =====
    async listarPermissoesGrupo(groupId) {
        const response = await api.get(`/permissions/grupos/${groupId}/permissoes`);
        return response.data;
    },

    async atualizarPermissao(groupId, appName, permissoes) {
        const response = await api.put(`/permissions/grupos/${groupId}/permissoes/${appName}`, permissoes);
        return response.data;
    },

    async atualizarPermissoesEmLote(groupId, permissoes) {
        const response = await api.post(`/permissions/grupos/${groupId}/permissoes/lote`, {
            permissoes
        });
        return response.data;
    },

    async obterPermissoesUsuario(login) {
        const response = await api.get(`/permissions/usuarios/${login}/permissoes`);
        return response.data;
    }
};
